module.exports = __webpack_public_path__ + "static/img/kefu.8c2d3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kefu.jpg
// module id = s62t
// module chunks = 1